var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "track",
      staticClass: "vks-zoom-center-track",
      class: { "is-inactive": _vm.regionZoom <= 0 },
    },
    [
      _c("div", {
        ref: "marker",
        staticClass: "vks-zoom-center-marker",
        style: _vm.markerStyle,
        attrs: {
          role: "slider",
          tabindex: "0",
          "aria-label": "Zoom center",
          "aria-valuemin": -100,
          "aria-valuemax": 100,
          "aria-valuenow": _vm.regionViewArea,
          "aria-disabled": _vm.regionZoom <= 0 ? "true" : "false",
        },
        on: {
          mousedown: function ($event) {
            $event.stopPropagation()
            return _vm.onMarkerMouseDown.apply(null, arguments)
          },
          keydown: _vm.onMarkerKeyDown,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }